import { useState } from "react";
import { Gift, Loader2, CheckCircle2, PartyPopper } from "lucide-react";
import { useMembership } from "@/context/MembershipContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export const MembershipSignup = () => {
  const { member, register, discountPct } = useMembership();
  const [form, setForm] = useState({ name: "", phone: "", email: "" });
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) { toast.error("Escribe tu nombre y teléfono"); return; }
    setLoading(true);
    try {
      await register(form);
      toast.success("¡Registro exitoso! Tu 5% se aplicará en tu primer pedido 🎁");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo registrar");
    } finally { setLoading(false); }
  };

  if (member) {
    return (
      <div data-testid="membership-registered" className="rounded-[2rem] bg-sage/40 border border-[#E3E7E2] p-8 sm:p-12 text-center">
        <span className="grid place-items-center w-14 h-14 mx-auto rounded-2xl bg-white text-coral mb-4">
          {discountPct > 0 ? <Gift className="w-7 h-7" /> : <CheckCircle2 className="w-7 h-7" />}
        </span>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-charcoal">¡Hola de nuevo, {member.name.split(" ")[0]}! 🐾</h2>
        <p className="text-charcoal/75 mt-2 max-w-md mx-auto">
          {discountPct > 0
            ? `Tienes un ${discountPct}% de descuento listo para tu primer pedido. Se aplicará automáticamente en tu carrito.`
            : "Ya usaste tu descuento de bienvenida. ¡Gracias por ser parte de la familia!"}
        </p>
      </div>
    );
  }

  return (
    <div data-testid="membership-signup" className="rounded-[2rem] bg-peach/60 border border-[#E3E7E2] p-8 sm:p-12">
      <div className="grid md:grid-cols-2 gap-8 items-center">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.25em] uppercase text-coral"><PartyPopper className="w-4 h-4" /> Beneficio exclusivo</span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-charcoal tracking-tight mt-3">Regístrate y obtén 5% en tu primer pedido</h2>
          <p className="text-charcoal/75 mt-3">Es opcional y gratis. Únete a la familia de The Pet Shopping Co y disfruta de un descuento de bienvenida. 🎁</p>
        </div>
        <form onSubmit={submit} className="space-y-3 bg-white rounded-3xl p-6 border border-[#E3E7E2]">
          <input data-testid="membership-name" value={form.name} onChange={upd("name")} placeholder="Nombre completo" className="inp" />
          <input data-testid="membership-phone" value={form.phone} onChange={upd("phone")} placeholder="Teléfono (WhatsApp)" className="inp" />
          <input data-testid="membership-email" value={form.email} onChange={upd("email")} placeholder="Correo (opcional)" className="inp" />
          <button data-testid="membership-submit" type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 py-3.5 rounded-2xl bg-coral text-white font-bold hover:bg-coral-dark active:scale-95 transition-all disabled:opacity-60">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Gift className="w-5 h-5" />} Quiero mi 5%
          </button>
          <p className="text-[11px] text-muted-moss text-center">Registro opcional. No compartimos tus datos.</p>
        </form>
      </div>
    </div>
  );
};
